import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function LoadingScreen({isVisible, isSidebarVisible}: any) {

  const [showComponent, setShowComponent] = React.useState(false);

  React.useEffect(() => {
    if(isVisible === true){
      setShowComponent(true)
    }else{
      setTimeout(() => { setShowComponent(false) }, 900);
    }
  }, [isVisible]);

  return (
    <div className={`full-loading-screen-container ${isVisible ? 'transition-fade-in' : 'transition-fade-out'}`}>
      { showComponent &&
        <div className={`loading-screen-container ${isSidebarVisible ? '' : 'expand'}`}>
          <Box sx={{ display: 'flex', height: '10% !important', aspectRatio: '1'}}>
            <CircularProgress
              sx={{ color: (theme) => (theme.palette.mode === 'light' ? '#14DAA0' : '#14DAA0'),
                    height: '100% !important', aspectRatio: '1', width:'100% !important'
              }}
            />
          </Box>
        </div>
      }
    </div>
  );
}
